module.exports = __webpack_public_path__ + "img/ida-bell-wells-barnett.366deadd.png";